import React, { useState } from 'react';
import './footer.css';
import { useDispatch } from 'react-redux';
import { Button, Box } from "@mui/material";
import { CustomTextField, CustomTextareaAutosize } from '../form-elements/form-elements';
import { submitEmail, submitJoinRequest } from '../../features/email/emailSlice';
import * as yup from "yup";
// import socialFacebook from '../../assets/images/social/white/facebook.png';
// import socialInstagram from '../../assets/images/social/white/instagram.png';
// import socialYoutube from '../../assets/images/social/white/youtube.png';
// import socialTwitter from '../../assets/images/social/white/twitter.png';

// Define validation schema using Yup
const emailSchema = yup.object().shape({
  email: yup.string().email("Invalid email format").required("Email is required"),
});

const Footer = () => {
  const dispatch = useDispatch();
  const [messageFormData, setMessageFormData] = useState({ name: '', email: '', message: '' });
  const [emailSignupData, setEmailSignupData] = useState({ email: '' });
  const [errors, setErrors] = useState({}); // Holds validation errors

  const validateEmail = async (email) => {
    try {
      await emailSchema.validate({ email });
      return null;
    } catch (error) {
      return error.message;
    }
  };

  const handleFormChange = (field, value) => {
    setMessageFormData({ ...messageFormData, [field]: value });
    if (field === "email") {
      validateEmail(value).then((error) => setErrors((prev) => ({ ...prev, email: error })));
    }
  };

  const handleEmailChange = (field, value) => {
    setEmailSignupData({ ...emailSignupData, [field]: value });
    if (field === "email") {
      validateEmail(value).then((error) => setErrors((prev) => ({ ...prev, signupEmail: error })));
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const emailError = await validateEmail(messageFormData.email);
    if (emailError) {
      setErrors((prev) => ({ ...prev, email: emailError }));
      return;
    }
    dispatch(submitEmail(messageFormData));
    setMessageFormData({ name: '', email: '', message: '' });
  };

  const handleEmailJoinSubmit = async (event) => {
    event.preventDefault();
    const emailError = await validateEmail(emailSignupData.email);
    if (emailError) {
      setErrors((prev) => ({ ...prev, signupEmail: emailError }));
      return;
    }
    dispatch(submitJoinRequest(emailSignupData));
    setEmailSignupData({ email: '' });
  };

  return (
    <div className='footer-container'>
      <div className='mail-form-container'>
        <div>
          <div className='small-copy'>FEEDBACK OR INQUIRIES</div>
          <div className='mail-form-header'>Have a question?</div>

          <Box>
            <CustomTextField
              size="small"
              label="YOUR NAME"
              name="name"
              value={messageFormData.name}
              onChange={(e) => handleFormChange("name", e.target.value)}
              variant="outlined"
              fullWidth
              sx={{ width: '100%', marginBottom: '10px' }}
            />

            <CustomTextField
              size="small"
              label="EMAIL"
              name="email"
              value={messageFormData.email}
              onChange={(e) => handleFormChange("email", e.target.value)}
              variant="outlined"
              fullWidth
              error={!!errors.email}
              helperText={errors.email}
              sx={{ width: '100%', marginBottom: '10px' }}
            />

            <CustomTextareaAutosize
              size="small"
              label="MESSAGE"
              name="message"
              value={messageFormData.message}
              onChange={(e) => handleFormChange("message", e.target.value)}
              variant="outlined"
              sx={{
                width: '100%', marginBottom: '10px',
                minHeight: '100px', maxHeight: '250px',
                boxSizing: 'borderBox', overflow: 'auto'
              }}
            />
          </Box>

          <Button
            sx={{ width: '86px', height: '32px', borderRadius: '4px', marginBottom: '20px', marginTop: '10px' }}
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            onClick={(event) => handleFormSubmit(event)}
          >
            Submit
          </Button>
        </div>
      </div>

      <div className='info-container'>
        <div className='info-container-item-block'>
          <div className='info-container-item-header'>JOIN OUR NEWSLETTER</div>
          <Box className='join-request-container'>
            <CustomTextField
              size="small"
              label="EMAIL"
              name="email"
              value={emailSignupData.email}
              onChange={(e) => handleEmailChange("email", e.target.value)}
              variant="outlined"
              fullWidth
              error={!!errors.signupEmail}
              helperText={errors.signupEmail}
              sx={{ width: '100%', marginBottom: '10px' }}
            />
            <Button
              sx={{ width: '86px', height: '32px', borderRadius: '4px', marginLeft: '10px' }}
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              onClick={(event) => handleEmailJoinSubmit(event)}
            >
              Join
            </Button>
          </Box>
        </div>

        {/*
				<div className='info-container-item-block'>
					<div className='social-container'>
						<img className='social' src={socialFacebook} alt='Facebook' />
						<img className='social' src={socialInstagram} alt='Instagram' />
						<img className='social' src={socialYoutube} alt='Youtube' />
						<img className='social' src={socialTwitter} alt='X' />
					</div>
				</div>
        */}

      </div>
    </div>
  );
};

export default Footer;
